import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import convertDateOverTime from '../../../../helpers/convertDateOverTime'
import {Tag} from 'antd'

function EmbroideryErrorRow(props) {
    const { item, setType, setBrand } = props
    const { batch, embroidery_error, product_type} = item
    const { partner, tags } = { ...batch }

    const barcode_number = item.item.marketplace
    const item_number = item.item.item_number
    const brand = item.item.brand
    const barcodeNumber = barcode_number + '_' + item_number
    const overTime = item.item.overtime

    const isSampleTag = Array.isArray(tags) && tags.includes('sample')
    const isGiftTag = Array.isArray(tags) && tags.includes('gift')
    const isUIDSAMPLETag = Array.isArray(tags) && tags.includes('UIDSAMPLE')
    const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
    const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
    const isCutOff = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isSLLTag = Array.isArray(tags) && tags.includes('SLL')
    const isTikTok = Array.isArray(tags) && tags.includes('tiktok')
    const is24hTag = Array.isArray(tags) && tags.includes('24h')
    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isComboSock = Array.isArray(tags) && tags.includes('combo_socks')
    
    const onClickBrand = (value) => {
        setBrand(value)
    }

    const onClickType = (value) => {
        setType(value)
    }

    function _detectChecked() {
        const {item, selectedBatchId} = props

        return selectedBatchId.includes(item.item._id)
    }

    function _handleChange() {
        const {item, onUpdateSelectedBatches} = props
        const isChecked = _detectChecked()

        onUpdateSelectedBatches(item.item._id, !isChecked, item.item._id)
    }

    const overtimeText = !!overTime ? convertDateOverTime(overTime) : '-'

    return (
        <tr>
            <td className="BatchSelectedAll">
                <input
                    type="checkbox"
                    checked={_detectChecked()}
                    onChange={_handleChange}
                />
            </td>
            <td>
                <div className="d-flex flex-column">
                    {!!barcode_number &&
                        <Link
                            to={`/order-item?template=${barcodeNumber}`}
                            target='_blank'>
                            #{barcodeNumber}
                        </Link>
                    }

                    {
                        isSampleTag && 
                        <div className='mb-1'><Tag color="#6c757d">Hàng mẫu</Tag></div>
                    }

                    {
                        isGiftTag && 
                        <div className='mb-1'><Tag color="#6c757d">Hàng tặng</Tag></div>
                    }

                    {
                        isFbaTag && 
                        <div className='mb-1'><Tag color="#6c757d">FBA</Tag></div>
                    }

                    {
                        isUIDSAMPLETag && 
                        <div className='mb-1'><Tag color="#6c757d">UIDSAMPLE</Tag></div>
                    }

                    {
                        isFastShipTag && 
                        <div className='mb-1'><Tag color="#6c757d">Ship nhanh</Tag></div>
                    }

                    {
                        isTikTok && 
                        <div className='mb-1'><Tag color="#dc3644">TIKTOK</Tag></div>
                    }

                    {
                        is24hTag &&
                        <div className='mb-1'><Tag color="#dc3644">24h</Tag></div>
                    }

                    {
                        isFastProductionTag && 
                        <div className='mb-1'><Tag color="#FFA500">Sản xuất nhanh</Tag></div>
                    }

                    {
                        isCutOff && 
                        <div><Tag color="#FF6600">cutoff</Tag></div>
                    }

                    {
                        isCutOffNewYear &&
                        <div><Tag color="#FF6600">cutoff_new_year</Tag></div>
                    }

                    {
                        isCutOffNoel &&
                        <div><Tag color="#FF6600">cutoff_noel</Tag></div>
                    }

                    {
                        isSLLTag &&
                        <div><Tag color="#fdb813">SLL</Tag></div>
                    }

                    {
                        isComboSock &&
                        <div>
                            <Tag color="#d334ce">Combo socks</Tag>
                        </div>
                    }
                </div>
            </td>
            <td className='ProductType'>
                {!!product_type &&
                    <span className="mr-2" onClick={() => onClickType([product_type])}>{product_type}</span>
                }
                {!!brand && !!brand.name &&
                    <div className='Brand'>
                        <span className="mr-2" onClick={() => onClickBrand([brand.name])}>{brand.name}</span>
                    </div>
                }
            </td>
            <td>{item.item.size || '-'}</td>
            <td>{moment(embroidery_error.pending_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td>{!!embroidery_error && !!embroidery_error.type ? embroidery_error.type : '-'}</td>
            <td className='OverTime d-flex align-items-center'>
                {overTime > 0 &&
                    <label
                        className='btn btn-sm mr-1 mb-0'
                        style={{
                            background: 'rgb(255 77 80)',
                            color: 'white',
                        }}
                    >
                        Quá hạn
                    </label>
                }
                <span className={`mb-0 ${overTime > 0 ? 'text-danger' : ''}`}>{overtimeText}</span>
            </td>
            <td>{!!partner && !!partner.name ? partner.name : '-'}</td>
        </tr>
    )
}

export default EmbroideryErrorRow